<template>
  <div>
    <div class="container" v-if="isMobile || !isFeaturedDeals">
      <div class="details-container" :class="{ 'info-mobile': isMobile }">
        <h3 v-if="title">{{ title }}</h3>
        <div v-if="totalDeals" :class="{ 'mt-3': isMobile }">
          <span class="deals">{{
            translate('offDealsSliderTotalDeals', totalDeals, totalDeals)
          }}</span>
          {{ ' · ' }}
          <span class="see__more" @click="emitSeeAll">{{ translate('offDealsSliderSeeAll') }}</span>
        </div>
      </div>
    </div>
    <GlideSlider
      :slides="offers"
      v-if="offers.length > 0"
      :isMobile="isMobile"
      :withContainer="withContainer"
      :is-featured-deals="isFeaturedDeals"
      :slidesPerView="slidesPerView"
    />
  </div>
</template>

<script>
import GlideSlider from '@/components/offers/GlideSlider'

export default {
  name: 'OffersSlider',
  components: {
    GlideSlider
  },
  emits: ['seeAll'],
  props: {
    offers: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    totalDeals: {
      type: Number,
      required: true
    },
    isFeaturedDeals: {
      type: Boolean,
      default: false
    },
    slidesPerView: {
      type: Number,
      default: 4
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    filters: {
      type: [Array, Object],
      required: true
    },
    withContainer: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    emitSeeAll() {
      this.$emit('seeAll', this.filters)
    }
  }
}
</script>

<style lang="scss" scoped>
.details-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  vertical-align: baseline;
  padding: 2rem 0;
  h3 {
    line-height: 3rem;
    font-size: 2.5rem;
    color: color('dark-grey');
    padding: 0;
  }
  .deals {
    font-weight: 200;
    color: color('grey-cool');
  }
  .see__more {
    color: #c00c0d;
    cursor: pointer;
    text-decoration: underline;
  }
}
.info-mobile {
  flex-direction: column;
  align-items: flex-start;
}
</style>
